<template>
  <section class="toast-container">
    <transition-group
      appear
      name="toast"
    >
      <section
        class="toast"
        v-for="(toast, index) in toasts"
        :key="`key-${index}`"
      >
        <!-- Types: "error", "success", "neutral"  --->
        <div :class="`toast-${toast.type}`">
          <section class="toast-icon">
            <Icon
              :name="iconName(toast.type)"
              :fills="iconFills(toast.type)"
            />
          </section>
          <section class="toast-info">
            <p class="copy">
              {{ $t(toast.message) }}
            </p>
          </section>
        </div>
      </section>
    </transition-group>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import Icon from "./Icon.vue";

export default {
  name: "Toast",
  components: {
    Icon,
  },
  computed: {
    ...mapGetters(["toasts"]),
  },
  methods: {
    iconName(type) {
      if (type === "error") return "warning";
      return "success";
    },
    iconFills(type) {
      if (type === "error") return ["#ef455c"];
      return ["#69bf78"];
    },
  },
};
</script>
